import './App.css';
import Footer from './components/Footer';

import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Homepage from './pages/Homepage';
import AboutUs from './pages/AboutUs';
import TradingPlatforms from './pages/TradingPlatforms';
import InvestmentProducts from './pages/InvestmentProducts';
import Contact from './pages/Contact';
import Register from './pages/Register';
import ScrollToTop from "./components/ScrollToTop"

function App() {
    return (
        <>
            <Router>
                <ScrollToTop />
                <Routes>
                    <Route path='/' element={<Homepage />}></Route>
                    <Route path='/about-us' element={<AboutUs />}></Route>
                    <Route path='/trading-platforms' element={<TradingPlatforms />}></Route>
                    <Route path='/investment-products' element={<InvestmentProducts />}></Route>
                    {/* <Route path='/contact' element={<Contact />}></Route> */}
                    <Route path='/register' element={<Register />}></Route>
                </Routes>
                <Footer />
            </Router>
        </>
    );
}

export default App;
